<script setup lang="ts">
import { TabKey } from '@apps/main/new-desktop/core/stores/configurationPanel/configurationPanelStore.model';

import { CarTripModalType } from '../models';
import { useCarTripPageStore } from '../stores/carTripPageStore';
import { useCarTripModalsStore } from '../stores/carTripModalsStore';

import MissedChangePaxModal from './MissedChangePaxModal.vue';

const carTripModalsStore = useCarTripModalsStore();
const carTripPageStore = useCarTripPageStore();

function onGoBackAndChangePaxes(): void {
  onClose();
  carTripPageStore.handleTabSwitch(TabKey.Pax);
}

function onContinue(): void {
  onClose();
  carTripPageStore.goToTripPlannerOverview();
}

function onClose(): void {
  carTripModalsStore.closeMissedChangePaxesModal();
}
</script>

<template>
  <MissedChangePaxModal
    v-if="
      carTripModalsStore.carTripModalType === CarTripModalType.MissedChangePaxes
    "
    @go-back-and-change="onGoBackAndChangePaxes"
    @continue="onContinue"
    @close="onClose"
  />
</template>

<style scoped lang="scss"></style>
